import {gql} from "@apollo/client";

export const CONTRACT_TEMPLATES = gql`
    query contractTemplates {
        contractTemplates {
            id
            contractType
            body
        }
    }
`;

export const UPSERT_CONTRACT_TEMPLATE = gql`
    mutation upsertContractTemplate($input: ContractTemplateInput!) {
        upsertContractTemplate(input: $input) {
            id
            contractType
            body
        }
    }
`;

export const CONTRACT_TEMPLATE_BY_ID = gql`
    query contractTemplateById($id: Int!){
        contractTemplateById(id: $id) {
            id
            contractType
            body
        }
    }
`;
